import * as React from 'react';
import {connect} from 'react-redux';

import {destroy} from 'redux-form';

import {Dialog} from 'shells/dialog/dialog';
import {Modal} from 'shells/modal/modal';

import type {
    SessionUser as SessionUserFragment,
    EntityRelatedEmailAddresses as EntityRelatedEmailAddressesFragment,
} from 'nutshell-graphql-types';

import type {NutshellState} from '../../../store';

import {minimizeComposer, closeComposer} from '../email-composer-actions';
import {getWasMinimizedForEntityId} from '../email-composer-selectors';

import {EmailSenderNew} from './sender-with-groups/email-sender-new';
import {FORM_NAME} from './types';

type OwnProps = {
    user: SessionUserFragment;
    entity: EntityRelatedEmailAddressesFragment;
    isOpen: boolean;
    seededWithEmailAddress: string | null | undefined;
    seedWithAllPrimaryRelatedEmailAddresses: boolean | null | undefined;
};

type StateProps = {
    wasMinimizedForEntityId: string | null | undefined;
};

type DispatchProps = {
    destroyForm: () => void;
    minimize: () => void;
    close: () => void;
};

type Props = OwnProps & StateProps & DispatchProps;

type State = {
    isShowingCloseDialog: boolean;
    hasEditedEmail: boolean;
};

// @ts-expect-error
function mapDispatchToProps(dispatch, ownProps: OwnProps): DispatchProps {
    return {
        destroyForm: () => {
            dispatch(destroy(FORM_NAME));
        },
        minimize: () => {
            dispatch(minimizeComposer({entityId: ownProps.entity.id}));
        },
        close: () => {
            dispatch(closeComposer());
        },
    };
}

function mapStateToProps(state: NutshellState): StateProps {
    return {
        wasMinimizedForEntityId: getWasMinimizedForEntityId(state),
    };
}

class EmailSenderModalComponent extends React.PureComponent<Props, State> {
    cancelButtonRef: HTMLElement | null | undefined;

    constructor() {
        // @ts-expect-error
        super();

        this.state = {
            isShowingCloseDialog: false,
            hasEditedEmail: false,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        // Clear the form data when opening the modal for a different entity.
        // TODO: Ask before destroying.
        if (
            this.props.wasMinimizedForEntityId !== this.props.entity.id &&
            nextProps.isOpen &&
            !this.props.isOpen
        ) {
            this.props.destroyForm();
        }
    }

    render() {
        return (
            <>
                <Modal
                    headerText={`Send email to ${this.props.entity.name}`}
                    onMinimize={this.props.minimize}
                    isWide={true}
                    isOpen={this.props.isOpen}
                    canClickOutsideToClose={false}
                    onBeforeClose={this.handleCloseButtonPress}
                    waitForMount={true}
                    getCloseButtonRef={(ref) => (this.cancelButtonRef = ref)}
                >
                    <EmailSenderNew
                        entity={this.props.entity}
                        user={this.props.user}
                        seededWithEmailAddress={this.props.seededWithEmailAddress}
                        seedWithAllPrimaryRelatedEmailAddresses={
                            this.props.seedWithAllPrimaryRelatedEmailAddresses
                        }
                        relatedEmailAddresses={this.props.entity.relatedEmailAddresses}
                        relatedLeads={this.props.entity.emailableLeads}
                        closeModal={this.handleSubmitSuccess}
                        shouldRestoreFromStorage={
                            this.props.wasMinimizedForEntityId === this.props.entity.id ||
                            this.state.hasEditedEmail
                        }
                        onEmailEdited={() => this.setState({hasEditedEmail: true})}
                    />
                </Modal>
                {this.state.isShowingCloseDialog && this.state.hasEditedEmail && (
                    <Dialog
                        anchor={this.cancelButtonRef}
                        question='Uh oh! You’re about to lose your changes. Are you sure you’d like to close this and cancel your changes?'
                        primaryText='Yes, cancel changes'
                        secondaryText='No, keep editing'
                        isWarning={true}
                        onPrimary={() => {
                            this.setState({isShowingCloseDialog: false, hasEditedEmail: false});
                            this.handleClose();
                        }}
                        onSecondary={() => {
                            this.setState({isShowingCloseDialog: false});
                        }}
                        location='bottom'
                    />
                )}
            </>
        );
    }

    handleSubmitSuccess = () => {
        Timeline.refreshTimeline();

        this.props.close();
    };

    handleCloseButtonPress = () => {
        if (!this.state.hasEditedEmail) {
            this.handleClose();

            return;
        }

        this.setState({isShowingCloseDialog: true});

        return false;
    };

    handleClose = () => {
        // Check to see if modal is open, because if coming through a form submission,
        // this will have already occurred.
        if (this.props.isOpen) {
            this.props.close();
        }

        this.props.destroyForm();
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const EmailSenderModal = connector(EmailSenderModalComponent);
